import React from 'react';

interface LogoPreviewProps {
  logoUrl: string | null;
  primaryColor: string;
  secondaryColor: string;
  fontFamily: string;
  fontSize: number; // px
  heading: string;
  subtext: string;
}

const LogoPreview: React.FC<LogoPreviewProps> = ({
  logoUrl,
  primaryColor,
  secondaryColor,
  fontFamily,
  fontSize,
  heading,
  subtext,
}) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-1">Preview</h3>
      <p className="text-sm text-gray-600 mb-4">See your changes here</p>

      <div className="w-[360px] mx-auto bg-gray-100 rounded-lg shadow border border-gray-200 overflow-hidden">
        {/* Inner card */}
        <div className="w-[300px] mx-auto my-6 bg-white rounded-md shadow-sm border border-gray-200 p-6 space-y-4">
          <div className="flex flex-col items-start gap-2">
            <div className="w-10 h-10 rounded bg-gray-50 overflow-hidden flex items-center justify-center">
              {logoUrl ? (
                <img src={logoUrl} alt="Logo" className="w-full h-full object-contain" />
              ) : (
                <div className="text-xs text-gray-500">Logo</div>
              )}
            </div>
            <div className="leading-tight text-left">
              <div className="font-semibold" style={{ fontFamily, fontSize, color: primaryColor }}>{heading}</div>
              <div className="text-[10px]" style={{ color: secondaryColor }}>{subtext}</div>
            </div>
          </div>

          <div className="space-y-2">
            <div className="text-[11px] text-gray-700">Mobile Number</div>
            <input className="w-full h-9 px-3 rounded border border-gray-200 text-[12px]" placeholder="+91 1234 5678 90" />
          </div>
          <div className="space-y-2">
            <div className="text-[11px] text-gray-700">Password</div>
            <input className="w-full h-9 px-3 rounded border border-gray-200 text-[12px]" placeholder="passwordgoeshere" />
          </div>

          <div className="flex items-center justify-between text-[10px] text-gray-600">
            <label className="inline-flex items-center gap-2">
              <input type="checkbox" className="rounded border-gray-300" />
              Remember me
            </label>
            <button className="hover:underline text-blue-600">Forgot Password?</button>
          </div>

          <button
            className="w-full h-9 rounded text-white text-[12px]"
            style={{
              backgroundImage: `linear-gradient(to right, #3b82f6, #2563eb)`,
            }}
          >
            Login
          </button>

          <button
            className="w-full h-9 rounded text-white text-[12px] mt-4"
            style={{
              backgroundColor: '#1f2937',
            }}
          >
            Register Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoPreview;


